<!-- Step 3 : Print shipment details Page -->
<app-shipment-details [shpId]="shpId"></app-shipment-details>
     

